const state = {
	districtInfo: {
		provinceId: '',
		provinceName: '',
		cityId: '',
		cityName: '',
		districtId: '',
		districtName: ''
	}
}

const mutations = {
	setDistrictInfo(state, districtInfo) {
		state.districtInfo = districtInfo || {
			provinceId: '',
			provinceName: '',
			cityId: '',
			cityName: '',
			districtId: '',
			districtName: ''
		}
	}
}

const actions = {
	setDistrictInfo({commit}, districtInfo) {
		commit('setDistrictInfo', districtInfo)
	}
}

export default {
	state,
	mutations,
	actions,
	namespaced: false
}



// WEBPACK FOOTER //
// ./src/store/modules/district.js